import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
} from "@mui/material";

interface FullScreenUploadDialogProps {
  open: boolean;
  titleText?: string;
  msgText?: string;
  onClose: () => void;
}

const FullScreenUploadDialog: React.FC<FullScreenUploadDialogProps> = ({
  open,
  titleText, 
  msgText,
  onClose,
}) => {
  useEffect(() => {
    if (open) {
      // Disable back press or window close during upload
      const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        e.preventDefault();
        e.returnValue =
          "Please do not close the window or navigate away during the upload.";
      };
      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          padding: "20px",
        }}
      >
        <CircularProgress size={60} style={{ color: "#E8772C" }} />
        <Typography variant="h6" style={{ marginTop: "20px" }}>
          {titleText ?? "Processing..."}
        </Typography>
        <Typography
          variant="body1"
          style={{ marginTop: "20px", color: "gray" }}
        >
          {msgText ?? "Please do not close the window or press back during the upload process."}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenUploadDialog;
